import { IRevisione } from '../../models/interfaces/revisione.interface';
import { JsonHelper } from '@core/helpers/json.helper';
import { IndexedDBService } from '@core/services/indexeddb.service';
import { JSON_FILE_PREFIX } from '@shared/constants/shared.constants';
import { Observable } from 'rxjs';

const getAllegatiPositionAndValue = (revisione: IRevisione, startsWith = IndexedDBService.idPrefix): { position: string; value: string }[] => {
    let flattenedRevisione = JsonHelper.flattenJson(revisione);

    return Object.entries(flattenedRevisione)
        .filter(([index, value]) => {
            const regex = new RegExp('^' + startsWith);
            return regex.test(String(value));
        })
        .map(([revisioneKey, allegatoValue]) => {
            return {
                position: revisioneKey,
                value: allegatoValue as string,
            };
        });
};

const fromBase64StringToFile = (base64String: string): File => {
    const groups = base64String.match(new RegExp(JSON_FILE_PREFIX)).groups;

    const type = groups.fileType;
    const fileName = groups.fileName;

    const b64 = base64String.split(',')[1];

    const decodedB64 = atob(b64);

    const buffer = new ArrayBuffer(decodedB64.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < decodedB64.length; n++) {
        view[n] = decodedB64.charCodeAt(n);
    }

    // convert ArrayBuffer to Blob
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { type });
};

const fromFileToBase64String = (file: File): Observable<string> => {
    return new Observable((subscriber) => {
        if (!file) {
            subscriber.error('File is undefined');
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            subscriber.next(reader.result as string);
            subscriber.complete();
        };

        reader.onerror = (error) => {
            subscriber.error(error);
        };
        reader.readAsDataURL(file);
    });
};
/*
const toBase64 = file => new Promise((resolve, reject) => {

});
*/

export const revisione53CoreHelpers = {
    getAllegatiPositionAndValue,
    fromBase64StringToFile,
    fromFileToBase64String,
};
